<h3>Literature and curation metrics</h3>

<div id="container">
  <div class="text-summary">
    <h4>Summary</h4>
    <div class="section-body stats-ribbon">
      <app-stats-summary></app-stats-summary>
    </div>
    <h4>{{gocamCount}} GO-CAM pathways</h4>
    <div class="other-stats-body">
      <ul>
        <li>
          <a routerLink="/gocam/pathway-metrics">GO-CAM pathway metrics</a>
        </li>
      </ul>
    </div>
    <h4>Other statistics</h4>
    <div class="other-stats-body">
      <ul>
        <li>
          <a routerLink="/status/protein-status-tracker">Protein-coding gene characterisation status</a>
        </li>
        <li>
          <a href="https://curation.pombase.org/pombe/stats/annotation">Community curation stats from Canto</a>
        </li>
      </ul>
    </div>
  </div>

<div>
  <h4>
    Genes in GO-CAM pathway models over time
  </h4>
  <a href="/assets/go-cam-date-vs-gene-count.svg"
     title="Genes in GO-CAM pathways over time (click for larger view)">
  <img class="plot-image" alt="Genes in GO-CAM pathways over time"
       src="/assets/go-cam-date-vs-gene-count.svg" />
  </a>
</div>

<div>
  <h4>
    Number of GO-CAM pathway models over time
  </h4>
  <a href="/assets/go-cam-date-vs-model-count.svg"
     title="Number of GO-CAM pathways over time">
    <img class="plot-image" alt="Number of GO-CAM pathways over time"
         src="/assets/go-cam-date-vs-model-count.svg" />
  </a>
</div>


<div>
  <div *ngIf="!cumulativeByYearPlotLoaded">
    Loading ...
  </div>
  <h4 *ngIf="cumulativeByYearPlotLoaded">
    Publication status (cumulative):
  </h4>
  <a href="/api/v2/dataset/latest/stats/cumulative_curated_by_year"
     title="Cumulative plot of publication status">
  <img (load)="cumulativeByYearPlotLoaded=true" class="plot-image"
       alt="Cumulative plot of publication status"
       src="/api/v2/dataset/latest/stats/cumulative_curated_by_year"/>
  </a>
</div>

<div>
  <div *ngIf="!communityResponseRates">
    Loading ...
  </div>
  <h4 *ngIf="cumulativeByYearPlotLoaded">
    Community curation response rate:
  </h4>
  <a href="/api/v2/dataset/latest/stats/community_response_rates"
     title="Cumulative community curation response rate">
  <img (load)="communityResponseRates=true" class="plot-image"
    alt="Cumulative community curation response rate"
    src="/api/v2/dataset/latest/stats/community_response_rates" />
  </a>
</div>

<div>
  <h4>
    GO annotation evidence codes over time:
    <span [popover]="goEvidenceByDatePopover" triggers="mouseenter:mouseleave" placement="bottom" container="body">
      <img class="help-icon" src="/assets/info_icon.svg">
      <ng-content></ng-content>
    </span>
  </h4>
  <a title="GO annotation evidence codes over time - click for larger view"
     href="/assets/pombase_history_go_ev_codes.svg">
    <img class="plot-image" alt="GO annotation evidence codes over time"
         src="/assets/pombase_history_go_ev_codes.svg" />
  </a>
</div>

<div class="wide-graph annotations-by-type">
  <div *ngIf="!cumulativeAnnotationByYearPlotLoaded">
    Loading ...
  </div>
  <h4 *ngIf="cumulativeAnnotationByYearPlotLoaded">
    Cumulative annotation type count by year

    <span [popover]="annotationTypePopover" triggers="mouseenter:mouseleave" placement="bottom" container="body">
      <img class="help-icon" src="/assets/info_icon.svg">
      <ng-content></ng-content>
    </span>
  </h4>
  <div class="graph-content">
    <div>
      <a href="/api/v2/dataset/latest/stats/cumulative_annotation_type_counts_by_year"
         title="Cumulative annotation type count by year">
      <img (load)="cumulativeAnnotationByYearPlotLoaded=true" class="plot-image"
        alt="Cumulative annotation type count by year"
        src="/api/v2/dataset/latest/stats/cumulative_annotation_type_counts_by_year" />
      </a>
    </div>
    <div class="stats-table" *ngIf="organismStats">
      Total annotations: {{organismStats.annotations}}
      <ul>
        <li *ngFor="let groupTotal of annotationGroupTotals">
          {{groupTotal[0]}}: {{groupTotal[1]}}
        </li>
      </ul>
    </div>
  </div>
</div>

<div>
  <div *ngIf="!cumulativeMicropublicationsPlotLoaded">
    Loading ...
  </div>
  <h4 *ngIf="cumulativeMicropublicationsPlotLoaded">
    Cumulative <i>S. pombe</i> microPublications per year:
  </h4>
  <a href="/api/v2/dataset/latest/stats/cumulative_micropublications_by_year"
     title="Cumulative S. pombe microPublications per year">
    <img (load)="cumulativeMicropublicationsPlotLoaded=true" class="plot-image"
      alt="Cumulative S. pombe microPublications per year"
      src="/api/v2/dataset/latest/stats/cumulative_micropublications_by_year" />
  </a>
</div>

<div>
  <div *ngIf="!curatedByYearPlotLoaded">
    Loading ...
  </div>
  <h4 *ngIf="curatedByYearPlotLoaded">
    Papers curated per year:
  </h4>
  <a href="/api/v2/dataset/latest/stats/curated_by_year"
     title="Curated papers">
  <img (load)="curatedByYearPlotLoaded=true" class="plot-image"
    alt="Curated papers"
    src="/api/v2/dataset/latest/stats/curated_by_year" />
  </a>
</div>

<div>
  <div *ngIf="!curatableByYearPlotLoaded">
    Loading ...
  </div>
  <h4 *ngIf="curatableByYearPlotLoaded">
    Curatable papers by year published:
  </h4>
  <a href="/api/v2/dataset/latest/stats/curatable_by_year"
     title="Curatable papers">
  <img (load)="curatableByYearPlotLoaded=true" class="plot-image" alt="Curatable papers"
    src="/api/v2/dataset/latest/stats/curatable_by_year" />
  </a>
</div>

<div>

  <h4>
    Average annotated genes per publications by year range (low throughput experiments only):
  </h4>
  <a href="/api/v2/dataset/latest/stats/ltp_genes_per_pub_per_year_range"
     title="Annotated genes per publications by year range">
  <img class="plot-image" alt="Annotated genes per publications by year range"
    src="/api/v2/dataset/latest/stats/ltp_genes_per_pub_per_year_range" />
  </a>
</div>

<div>
  <h4>
    Average annotations per publication by year range (low throughput experiments only):
  </h4>
  <a href="/api/v2/dataset/latest/stats/ltp_annotations_per_pub_per_year_range"
     title="Low throughput Annotations per publication by year range">
  <img class="plot-image" alt="Low throughput Annotations per publication by year range"
    src="/api/v2/dataset/latest/stats/ltp_annotations_per_pub_per_year_range" />
  </a>
</div>

<div>
  <h4>
    Average annotations per publication by year range (high throughput experiments only):
  </h4>
  <a href="/api/v2/dataset/latest/stats/htp_annotations_per_pub_per_year_range"
     title="Annotated genes per publications by year range">
  <img class="plot-image" alt="Annotated genes per publications by year range"
    src="/api/v2/dataset/latest/stats/htp_annotations_per_pub_per_year_range" />
  </a>
</div>

<div>
  <h4>
    Related documents
  </h4>
  <ul>
    <li>
      <a href="https://www.pombase.org/data/documents/journal_count_with_year.xlsx">Counts of pombe publications per journal per year</a> (Excel format - includes only publications in PomBase)
    </li>
  </ul>
</div>

</div>

<ng-template #goEvidenceByDatePopover>
  <div class="go-ev-by-date-popover">
    <div>
    PomBase filters redundant GO annotations from non-experimental sources
    when experimental data is available, and GO annotation from electronic
    sources when manual annotation is available. This graph shows the
    "filtered" GO annotations over time. Non experimental manual
    annotations not supported by a manual annotation are decreasing over
    time. Electronic annotations not supported by any other source are
    decreasing over time (&lt;1900).
    </div>
    <div>
    The total number of prefiltered
    electronic annotations now exceeds 38,000 (i.e. ~36,000 are covered by
    experimental or manual annotation).
    </div>
  </div>
</ng-template>

<ng-template #annotationTypePopover>
  <div class="annotation-type-popover">
    <div>This graph shows cumulative totals of manually curated annotations over time.</div>

    <div>
    Totals include annotations made by PomBase curators and fission yeast community but exclude annotations imported from
    other sources, and GO annotations based on computational methods (IEA evidence).
    All annotation types are described in the PomBase documentation.
    </div>
  </div>
</ng-template>
